import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Pill, DrawerHeader, Drawer, DrawerBody,
} from '@one-thd/sui-atomic-components';
import { CustomOptions } from '@one-thd/sui-icons';
import {
  QueryProvider, QueryContext, useDataModel, params, string, shape, bool
} from '@thd-nucleus/data-sources';
import { MoreLikeThisPlpWrapper, ZoneCard } from '@thd-olt-component-react/thd-recs-containers';
import { hideViewSimilarIcon } from '../../utils/helpers';

const ViewSimilarIcon = ({
  itemId,
  storeId
}) => {
  const { defaultVariables } = useContext(QueryContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    window.LIFE_CYCLE_EVENT_BUS.trigger('view-similar.morelikethisoverlay');
  };
  const handleClose = () => setOpen(false);
  const ctxDefaultVariables = {
    itemId,
    storeId,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const { loading, data, error } = useDataModel('product', {
    variables: { itemId, storeId },
  });

  if (loading || error || !data || hideViewSimilarIcon(data?.product)) {
    return null;
  }

  return (
    <>
      <Pill
        label="View Similar"
        onClick={handleOpen}
        icon={<CustomOptions />}
        style={{ fontSize: '14px' }}
      />
      {open && (
        <QueryProvider defaultVariables={ctxDefaultVariables} cacheKey="more-like-this-plp-drawer">
          <Drawer open={open} onClose={handleClose} position="right">
            <DrawerHeader title="Similar Items" onClose={handleClose} />
            <DrawerBody name="more-like-this-plp-drawer-body">
              <MoreLikeThisPlpWrapper
                schemaName="more_like_this"
                anchorId={itemId}
                storeId={storeId}
                errorBoundary
                requestKey="aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee"
                maxResults={18}
                hydrator={{
                  className: 'grid',
                  tag: ZoneCard,
                  id: `more_like_this-${itemId}`,
                  scrollBuffer: 0,
                  delay: 0
                }}
              />
            </DrawerBody>
          </Drawer>
        </QueryProvider>
      )}
    </>

  );
};

ViewSimilarIcon.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string
};

ViewSimilarIcon.defaultProps = {
  storeId: ''
};

ViewSimilarIcon.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    info: shape({
      isGenericProduct: bool(),
      globalCustomConfigurator: shape({ customExperience: string() })
    }),
    bundleFlag: bool(),
    identifiers: shape({ productType: string() })
  })
};

ViewSimilarIcon.displayName = 'ViewSimilarIcon';

export { ViewSimilarIcon };
